import {Service} from "@/apiServices/Service";

export class NuevoM2Service extends Service {
    constructor() {
        super('nuevo/m2/');
    }

    guardarDistribucionesPagoCero(idPTI) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar', 'distribucion', 'cero']), idPTI)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then(r => {
                this.toast.info("Datos guardados con éxito")
                return r;
            })
            .catch((e) => {
                this.toast.info(e.response.data.message);
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerNotasPti(pti) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'notas', 'pti']), {idPti: pti})
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                console.error(e)
                /*this.onError(e);*/
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerDatosVale(idPlan, idPaciente) {

        if (idPlan == undefined || idPlan == null) {
            return Promise.reject(new Error('fail'));
        }
        const parametros = {idPlan: idPlan, idPaciente: idPaciente}

        this.onStart();
        return this.http.post(this.getUrl(['obtenerDetalleSaldoPacienteVale']), parametros)
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                console.error(e)
                /*this.onError(e);*/
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
